import React, { useState, useEffect , useRef} from 'react';
import { Form } from 'react-bootstrap';
 
const DateTimePicker = (props = {}) => {
    let startDate = new Date();
    let state = {
        placeholder:"",
        disable:false,
        id:"",
        className:"",
        hidePlaceholder:false,
        styles:{width:"160px",marginLeft:"10px", height: "38px", fontSize: "inherit" },
        initialDate:"now"

    };
    state = {...state, ...props.options};
    if(state.initialDate !== "now"){
        startDate = state.initialDate;
    }
    const [selectedDate, setSelectedDate] = useState(startDate.getFullYear() + (startDate.getMonth()< 9 ? "-0" : "-") + (startDate.getMonth() + 1) + "-" + (parseInt(startDate.getDate()) < 10?"0"+startDate.getDate():startDate.getDate()));
    const handleDateTimePickerChange = (e) => {
        if(typeof props.SelectionChangeCallback === "function"){
            props.SelectionChangeCallback(e.target.value);
            setSelectedDate(e.target.value);
        }
        
    }
    // useEffect(() => {
    //     if(state.initialDate !== "now"){
    //         startDate = state.initialDate;
    //     }
    //     else
    //     {
    //         startDate = new Date();
    //     }
    //     setSelectedDate(startDate.getFullYear() + (startDate.getMonth()< 9 ? "-0" : "-") + (startDate.getMonth() + 1) + "-" + (parseInt(startDate.getDate()) < 10?"0"+startDate.getDate():startDate.getDate()));
        
    // }, [state]);
    return(
        <Form.Group><Form.Control type="date" placeholder="" style={state.styles} onChange={handleDateTimePickerChange} value={selectedDate} disabled={state.disable} /> </Form.Group>
    )
}
 
export default DateTimePicker;